import { BrowserRouter, HashRouter, Routes, Route } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";
import PublicLayout from "../layouts/PublicLayout";
import AdminLayout from "../layouts/AdminLayout";

import Dashboard from "../views/Dashboard";
import DashboardAlt from "../views/DashboardAlt";
import Login from "../views/Login";
import ResetPassword from "../views/ResetPassword";
import ChangePassword from "../views/ChangePassword";
import AdminDashboard from "../views/AdminDashboard";
import DynamicTable from "../views/DynamicTable";
import Graphs from "../views/Graphs";
import AlterGraphs from "../views/AlterGraphs";
import Example from "../components/graphs/Example";
import GroupsAdminSuite from "../views/GroupsAdminSuite";
import UserAdminSuite from "../views/UserAdminSuite";
import LicensesAdminSuite from "../views/LicensesAdminSuite";
import InvitationsAdminSuite from "../views/InvitationsAdminSuite";
import ResponseInvitation from "../views/ResponseInvitation";
import UsersGroupAdminSuite from "../views/UsersGroupAdminSuite";
import ScriptDownload from "../views/ScriptDownload";

// Componente separado para la ruta con HashRouter
const ScriptDownloadRoute = () => {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<ScriptDownload />} />
        </Route>
      </Routes>
    </HashRouter>
  );
};

const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rutas normales */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/dashboard-prototype" element={<DashboardAlt />} />
          <Route path="/dynamic-tables" element={<DynamicTable />} />
          <Route path="/graphs" element={<Graphs />} />
          <Route path="/alter-graphs" element={<AlterGraphs />} />
          <Route path="/example" element={<Example />} />   
        </Route>

        {/* Público */}
        <Route element={<PublicLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePassword />} />
          {/* Quitamos la ruta MML de aquí y la movemos abajo */}
        </Route>

        <Route path="/SmartMineCode-Scripts-MediaLuna" element={<ScriptDownload />} />

        {/* Ruta especial con HashRouter */}
        <Route path="/MML/*" element={<ScriptDownloadRoute />} />

        {/* Rutas de admin */}
        <Route element={<AdminLayout />}>
          <Route path="/admin-suite" element={<AdminDashboard />} />
          <Route path="/admin-suite/groups" element={<GroupsAdminSuite />} />
          <Route path="/admin-suite/users" element={<UserAdminSuite />} />
          <Route path="/admin-suite/invitations" element={<InvitationsAdminSuite />} />
          <Route path="/admin-suite/members" element={<UsersGroupAdminSuite />} />
          <Route path="/admin-suite/licenses" element={<LicensesAdminSuite />} />
          <Route path="/invitation" element={<ResponseInvitation />} />
        </Route>

      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;